/**
 * QuickMenu functionality with Back to Top features
 */
export function Init() {
  initBackToTopInQuickMenu();
  initQuickMenuToggle();
}

/**
 * Initialize Back to Top functionality only for QuickMenu
 */
function initBackToTopInQuickMenu() {
  // Only handle QuickMenu Back-to-Top buttons
  const quickMenuButtons = document.querySelectorAll('.quickmenu-backtotop');

  if (quickMenuButtons.length > 0) {

    quickMenuButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });

      button.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          console.log('QuickMenu Back-to-Top per Tastatur ausgelöst!');
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      });
    });
  } else {
    console.warn('No QuickMenu Back-to-Top buttons found');
  }
}

/**
 * Initialize QuickMenu Toggle functionality
 */
function initQuickMenuToggle() {
  const quickmenuTitles = document.querySelectorAll('.quickmenu-title');
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (quickmenuTitles.length > 0) {
    quickmenuTitles.forEach(title => {
      const linksId = title.getAttribute('aria-controls');
      const linksContainer = document.getElementById(linksId);

      if (linksContainer) {

        if (isMobile) {
          linksContainer.style.display = 'none';
          title.setAttribute('aria-expanded', 'false');
          title.classList.remove('active');

          title.addEventListener('click', function() {
            const expanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !expanded);

            if (expanded) {
              linksContainer.style.display = 'none';
              this.classList.remove('active');
            } else {
              linksContainer.style.display = 'block';
              this.classList.add('active');
            }
          });

          title.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
        } else {

          linksContainer.style.display = 'flex';
          title.setAttribute('aria-expanded', 'true');
          title.style.cursor = 'default';
        }
      }
    });
  } else {
    console.warn('No QuickMenu titles found');
  }

  window.addEventListener('resize', function() {
    const newIsMobile = window.matchMedia('(max-width: 768px)').matches;

    if (newIsMobile !== isMobile) {

      window.location.reload();
    }
  });
}
